export const dateFormatter = (date: string, time?:boolean): string => {
  const currentDate = new Date(Number(date) * 1000)
  return time ? currentDate.toLocaleTimeString('en-GB') : currentDate.toLocaleDateString('en-GB'); // en-US - American
  // return `${currentDate.getDate()}/${currentDate.getMonth()+1}/${currentDate.getFullYear()}`
}
